<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}}</h5>
      <div class="pull-right">
        <b-button v-if="section === ''" @click="section = 'edit'" variant="outline-primary"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''" :active="section === ''">Preview</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
export default {
  name: 'location_detail',
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    this.$store.commit('shipment_md/locations/SET_DETAIL_ID', this.locationId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'locations', name: 'Locations' },
      { to: this.locationId, name: 'Detail' },
    ]);
  },
  computed: {
    locationId() {
      return this.$route.params.locationId;
    },
    detailedInfo() {
      return this.$store.getters['shipment_md/locations/get_detail_data'];
    },
    displayName() {
      const { code, name } = this.detailedInfo;
      return `(${code}) ${name}`;
    },
  },
  watch: {
    section(newSection) {
      this.$router.push(`/shipment_md/locations/${this.locationId}/${newSection}`);
    },
    locationId(newLocationId) {
      this.$store.commit('shipment_md/locations/SET_DETAIL_ID', newLocationId);
      this.$store.dispatch('shipment_md/locations/LOAD_DETAIL_DATA');
      this.section = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/locations/Detail.vue